var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckedlike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 15.833,
    viewBox: "0 0 16.667 15.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_55840",
    "data-name": "Path 55840",
    d: "M15,5H10.325l.934-2.806a1.69,1.69,0,0,0-.225-1.5A1.69,1.69,0,0,0,9.675,0H8.333a.833.833,0,0,0-.642.3L3.775,5H1.667A1.67,1.67,0,0,0,0,6.667v7.5a1.67,1.67,0,0,0,1.667,1.667H12.759a1.7,1.7,0,0,0,.95-.3,1.666,1.666,0,0,0,.608-.783l2.3-6.126a.867.867,0,0,0,.05-.292V6.667A1.67,1.67,0,0,0,15,5ZM1.667,6.667H3.333v7.5H1.667ZM15,8.182l-2.241,5.984H5V6.135L8.725,1.667h.95l-1.3,3.9a.882.882,0,0,0-.033.39.741.741,0,0,0,.15.362.805.805,0,0,0,.292.255.843.843,0,0,0,.383.091H15Z",
    fill: "#758522"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedlike);
export default __webpack_public_path__ + "static/media/uncheckedlike.0f85a17e6d639f9b7f60df08df65a6bb.svg";
export { ForwardRef as ReactComponent };